import backend from "../utils/backend";
import {
  GET_LATEST_STORIES,
  GET_LATEST_STORIES_SUCCESS,
  GET_LATEST_STORIES_ERROR } from "../constants/actionTypes";

export const getLatestStories = () => {
  return (dispatch, getState) => {
    const state = getState();
    if (state.latestStories && state.latestStories.isLoading) {
      // Don't dispatch more requests for latest stories while API requests are still pending.
      return;
    }

    dispatch({
      type: GET_LATEST_STORIES,
    });

    return backend.request({
      method: "GET",
      url: "/most-recent/",
    })
      .then((response) => {
        dispatch({
          type: GET_LATEST_STORIES_SUCCESS,
          payload: response.data.results,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_LATEST_STORIES_ERROR,
          payload: err,
        });
      });
  };
};
